import React from 'react';

export function useInterval(callback, delay) {
    const intervalRef = React.useRef(null);
    const callbackRef = React.useRef(callback);

    React.useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    React.useEffect(() => {
        if (typeof delay === 'number') {
            intervalRef.current = setInterval(callbackRef.current, delay);
            return () => clearInterval(intervalRef.current);
        }
    }, [delay]);
    return intervalRef;
}

export const useWhyEffect = (name, cb, deps=[]) => { // eslint-disable-line no-unused-vars
    const oldDeps = React.useRef(deps);
    let diffDeps = {};
    for (let i = 0; i < deps.length; i++) {
        if(deps[i] !== oldDeps.current[i]) {
            diffDeps[deps[i]] = {
                old: oldDeps.current[i],
                new: deps[i]
            };
        }
    }
    oldDeps.current = deps;
    React.useEffect(cb, deps);
};

export const useWhyRender = (items) => {
    let oldItems = React.useRef(items);

    let diff = {};
    for(let k in items) { // eslint-disable-line no-unused-vars
        if (oldItems.current[k] !== items[k]) {
            diff[k] = {
                old: oldItems[k],
                new: items[k]
            }
        }
    }

    console.log('Rerendered because of:', diff);
    oldItems.current = items;
};

export const useBeforeunload = (funcToCall = () => {}) => {
    React.useEffect(() => {

        window.addEventListener('beforeunload', funcToCall);

        return () => {
            window.removeEventListener('beforeunload', funcToCall);
        };
    }, [funcToCall]);
};

